"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var swiper_1 = require("swiper");
var modules_1 = require("swiper/modules");
// ハンバーガーメニュー
var humMenu = function () {
    var modalMenu = document.getElementById('modalMenu');
    var menuBtn = document.getElementById('hamburgerToggle');
    var setClass = 'is_set';
    var isUnderPage = document.querySelector('.is_page');
    var body = document.querySelector('body');
    if (menuBtn != null && modalMenu != null && body != null) {
        menuBtn.addEventListener('click', function () {
            if (menuBtn.classList.contains(setClass)) {
                menuBtn.classList.remove(setClass);
                modalMenu.classList.remove(setClass);
                body.style.overflow = 'auto';
                // 下層ページの場合のみ、ロゴの色を変更
                if (isUnderPage !== null) {
                    var headerLogoImg = document.getElementById('headerLogo');
                    if (headerLogoImg != null) {
                        headerLogoImg.src = headerLogoImg.src.replace('logo.svg', 'logo-color.svg');
                    }
                }
            }
            else {
                menuBtn.classList.add(setClass);
                modalMenu.classList.add(setClass);
                body.style.overflow = 'hidden';
                // 下層ページの場合のみ、ロゴの色を変更
                if (isUnderPage !== null) {
                    var headerLogoImg = document.getElementById('headerLogo');
                    if (headerLogoImg != null) {
                        headerLogoImg.src = headerLogoImg.src.replace('logo-color.svg', 'logo.svg');
                    }
                }
            }
        });
    }
};
// 日時を設定
var targetDate = new Date('2025-08-01T00:00:00');
var updateCountdown = function () {
    var now = new Date();
    var timeRemaining = targetDate.getTime() - now.getTime();
    var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
    var elements = [
        { id: 'days', value: days },
        { id: 'hours', value: hours },
        { id: 'minutes', value: minutes },
        { id: 'seconds', value: seconds },
    ];
    for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
        var _a = elements_1[_i], id = _a.id, value = _a.value;
        var element = document.getElementById(id);
        if (element !== null)
            element.innerText = value.toString();
    }
};
var heroSwiper = function () {
    var swiper = new swiper_1.default('.hero-swiper', {
        modules: [modules_1.Navigation, modules_1.Pagination, modules_1.Autoplay, modules_1.EffectFade],
        loop: true,
        slidesPerView: 1,
        centeredSlides: true,
        autoplay: {
            delay: 3000,
        },
        speed: 3000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
    });
    swiper.init();
};
// recruit-top-swiper
var recruitTopSwiper = function () {
    var swiper = new swiper_1.default('.recruit-infinity-swiper', {
        modules: [modules_1.Autoplay],
        loop: true,
        slidesPerView: 3.5,
        centeredSlides: true,
        autoplay: {
            delay: 0,
        },
        speed: 15000,
    });
    swiper.init();
};
window.addEventListener('DOMContentLoaded', function () {
    humMenu();
    updateCountdown(); // 初回実行
    setInterval(updateCountdown, 1000); // 初回以降は1秒ごとに実行
    heroSwiper();
    recruitTopSwiper();
});
